import React, { useState } from "react";
import { Menu, Divider, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { dumontColors } from "../../../colors";
import {
  MenuButton,
  StyledMenuItem,
  MenuItemText,
  TooltipContent,
  TooltipArrow,
  MenuPaperProps,
} from "./styled";
import { ClearIcon, CopyIcon, DotsVerticalIcon, DownloadIcon } from "Components/Generic/Icons/Dumont";

export interface ChatActionsMenuProps {
  onCopyConversation?: () => void;
  onExportChat?: () => void;
  onClearConversation?: () => void;
}

export default function ChatActionsMenu({
  onCopyConversation,
  onExportChat,
  onClearConversation,
}: ChatActionsMenuProps) {
  const { t: translate } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyConversation = () => {
    onCopyConversation?.();
    handleClose();
  };

  const handleExportChat = () => {
    onExportChat?.();
    handleClose();
  };

  const handleClearConversation = () => {
    onClearConversation?.();
    handleClose();
  };

  return (
    <>
      <Tooltip
        title={translate("more")}
        placement="top"
        arrow
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 8],
                },
              },
            ],
          },
          tooltip: {
            sx: TooltipContent,
          },
          arrow: {
            sx: TooltipArrow,
          },
        }}
      >
        <MenuButton size="small" onClick={handleClick}>
          <DotsVerticalIcon sx={{ fontSize: 16, color: "#666666" }} />
        </MenuButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={MenuPaperProps}
      >
        <StyledMenuItem onClick={handleCopyConversation}>
          <CopyIcon sx={{ fontSize: 16, color: dumontColors.textTertiary }} />
          <MenuItemText>{translate("dumontCopyConversation")}</MenuItemText>
        </StyledMenuItem>

        <StyledMenuItem onClick={handleExportChat}>
          <DownloadIcon sx={{ fontSize: 16, color: dumontColors.textTertiary }} />
          <MenuItemText>{translate("dumontExportChat")}</MenuItemText>
        </StyledMenuItem>

        <Divider sx={{ margin: "4px 0", backgroundColor: "#E5E7EB" }} />

        <StyledMenuItem onClick={handleClearConversation} isDelete>
          <ClearIcon sx={{ fontSize: 16, color: "#D4183D" }} />
          <MenuItemText isDelete>{translate("dumontClearConversation")}</MenuItemText>
        </StyledMenuItem>
      </Menu>
    </>
  );
}
